module.exports = __webpack_public_path__ + "static/media/e27.02619df9.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/media/images/e27.png
// module id = 1819
// module chunks = 147